<div class="resident-review-container">

  <!-- Header Tabs -->
  <div class="tab-container">
    <button mat-flat-button color="primary" *ngif="false">All Residents</button>
    <button class="filter-btn" [class.active]="selectedListType === 'MCA'" (click)="getPDPMCores(0,'MCA')">
      All Active Medicare
    </button>

     <button class="filter-btn" [class.active]="selectedListType === 'MEDICAID'" (click)="getPDPMCores(0,'MEDICAID')">
      All Active Medicaid
    </button>

    <button class="filter-btn" [class.active]="selectedListType === 'HIPPS'" (click)="getPDPMCores(0,'HIPPS')">
      Other w/HIPPS
    </button>
     <button class="filter-btn" [class.active]="selectedListType === 'UnAssigned'" (click)="getPDPMCores(0,'UnAssigned')">
      Unassigned
    </button>
     <button class="filter-btn" [class.active]="selectedListType === 'Archived'" (click)="getPDPMCores(0,'Archived')">
      Archived
    </button>


    <!-- <button mat-stroked-button   class="btn"  [ngClass]="selectedListType === 'MCA' ? 'btn-primary' : 'btn-light'"    (click)="getPDPMCores(0,'MCA')">All Active MCA</button>
    <button mat-stroked-button  class="btn"   [ngClass]="selectedListType === 'HIPPS' ? 'btn-primary' : 'btn-light'"  (click)="getPDPMCores(0,'HIPPS')">Other w/HIPPS</button> -->
    <button mat-stroked-button *ngif="false">AI CONSULT</button>
    <button mat-stroked-button *ngif="false">
      Alerts <span class="alert-badge">2</span>
    </button>



    
    <div class="filters">

<div class="bulk-actions" *ngIf="selectedRows && selectedRows.length > 0">
  <button mat-icon-button color="warn" (click)="confirmDeleteSelected()" matTooltip="Delete Selected">
    <mat-icon>delete</mat-icon>
  </button>

 <button mat-icon-button color="primary" *ngIf="!isArchived" (click)="archiveSelected()" matTooltip="Archive Selected">
    <mat-icon>archive</mat-icon>
  </button>

  <!-- Unarchive selected -->
  <!-- <button mat-icon-button color="primary" *ngIf="isArchived" (click)="unarchiveSelected()" matTooltip="Unarchive Selected">
    <mat-icon>unarchive</mat-icon>
  </button> -->

</div>


      <mat-form-field class="compact-search" appearence="outline">
        <mat-label>Search {{CoreShowName}}</mat-label>
        <input matInput type="text" [(ngModel)]="searchResident"
          (keyup)="$event.keyCode == 13 ? Search($event.target.value) : ($event.target.value==''?Search($event.target.value):null)">
        <button mat-button *ngIf="searchResident" matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
          <mat-icon>close</mat-icon>
        </button>
        <button *ngIf="!searchResident" matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
          <mat-icon>search</mat-icon>
        </button>
      </mat-form-field>

      <!-- <mat-form-field appearance="outline" floatLabel="never" class="compact-search">
       <mat-icon matPrefix>search</mat-icon>
       <input matInput placeholder="Search {{CoreShowName}}..." [(ngModel)]="searchResident" />
      </mat-form-field> -->

      <!-- <button mat-stroked-button>All Payers</button>
      <button mat-stroked-button>Add Filter</button> -->
    </div>

 <button class="filter-btn openeepi active" color="primary" (click)="OpenEpisode(addUpdateCore,'MCA')">Open Episode</button>

  </div>


  <!-- Section: All Active MCA -->
  <mat-card class="review-card">
   <h3>{{listTitle}}</h3>

    <div class="table-container">
      <table class="custom-table">
        <thead>
          <tr>
            <th>
            <mat-checkbox [(ngModel)]="selectAll" (change)="toggleAllSelection($event)"></mat-checkbox>
             </th>
            <th>Resident</th>
            <th>Payer</th>
            <th>LOS Day</th>
            <th>ARD Date</th>         
            <th>HIPPS</th>
            <th>Care Level</th>
            <th>PT/OT/SLP/N/NTA</th>
            <th>PDPM Score</th>
            <th>Nursing/NTA's</th>
            <!-- <th>NTAS</th> -->
            <th>Rate</th>
            <th>Alert</th>
            <th>AI</th>
            <!-- <th></th> -->
            <th></th>
            <th>Documents</th>
            <th>Category</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of activeMCAResidents; let rowIndex = index">
          <td>
          <mat-checkbox [(ngModel)]="row.selected" (change)="onSelectRow(row)"></mat-checkbox>
            </td>

            <td>
              <div class="resident-info">
                <!-- | slice:0:1 -->
                <ng-container *ngFor="let field of getNameFields(row.core?.fields) | slice:0:1">
                  <div *ngIf="field.fieldName === 'Name'">
                    <div class="avatar" [ngStyle]="{background: setAlertColor(row.core.coreNTAStats.alertType) }">
                      {{getShortName( field.fieldValue)}}</div>
                  </div>


                </ng-container>
                <div class="resident-details">

                  <ng-container *ngFor="let field of getNameFields(row.core?.fields) | slice:0:1">
                    <div *ngIf="field.fieldName === 'Name'">
                      <span class="resident-name resident-link" style="color: #2e5bff;cursor: pointer;"
                        (click)="OpenDetails(row.core,'Detail')" >{{ field.fieldValue }} </span>
                      <button mat-icon-button color="primary" class="openNew" matTooltip="Open in new tab"
                        (click)="OpenProfile(row.core?.fields)">
                        <mat-icon>open_in_new</mat-icon>
                      </button>

                                       
                      <div class="d-flex">
                                                <button class="actIconbutton"
                          class="actIconbutton"
                          (click)="AddRowFavorite(row.core,selectFavColor)"
                        >
                            <mat-icon *ngIf="row.core.isFavorite == true" class="fav default-flag"
                            [ngStyle]="{ 'color': row.core.favouriteColorCode }" 
                            (click)="FavoriteSelectedRecordForDeleteCore(row.core)">grade</mat-icon>                                      
                        <mat-icon *ngIf="row.core.isFavorite == false" class="star default-flag" >grade</mat-icon>
                        </button>

<button 
  class="actIconbutton"
  > 
  <!-- When Important -->
  <i 
    *ngIf="row.core.isImportant" 
    class="fa fa-flag default-flag fav" 
    [ngStyle]="{ 'color': row.core.isImportantColorCode, 'cursor': 'pointer' }"
    (click)="DeleteImportant(row.core)">
  </i>

  <!-- When Not Important -->
  <i 
    *ngIf="!row.core.isImportant" 
    class="fa fa-flag default-flag star" 
    (click)="AddRowImportant(row.core, selectimpFavColor)"
     [ngStyle]="{ 'cursor': 'pointer' }">
  </i>
</button>

                     


                      <!-- <button  class="actIconbutton">
                                            <mat-icon 
  [ngClass]="row.core?.isImportant ? 'important-flag' : 'flag'" 
  (click)="toggleImportant(row.core)"
  style="cursor: pointer;">
  label
</mat-icon>   
                      </button> -->

                      <button class="actbutton" matTooltip="Add note" (click)="OpenDetails(row.core,'note')">
                        <i class="fa fa-plus" aria-hidden="true"></i>  Add Note
                      </button>
                      </div>
     


                    </div>

                  </ng-container>
                  <ng-container *ngFor="let field of getNameFields(row.core?.fields) | slice:0:1">
                    <span *ngIf="field.fieldName === 'Email'">
                      <small> {{ field.fieldValue }} <br> </small>
                    </span>
                  </ng-container>

                  <!-- <span class="resident-name">{{ row.name }}</span><br /> -->
                  <!-- <small>MRN {{ row.mrn }} • Room {{ row.room }}</small> -->
                </div>
              </div>
            </td>

            <td>{{ row.core.coreNTAStats.payer }}</td>
            <td>{{ row.core.coreNTAStats.losDay }}</td>   
            <td> </td>        
            <td>{{ row.core.coreNTAStats.hipps }}</td>
            <td>{{ row.core.coreNTAStats.careLevel }}</td>
            <!-- <td>{{ row.core.coreNTAStats.pt }}/{{ row.core.coreNTAStats.ot }}/{{ row.core.coreNTAStats.slp }}</td> -->
            <td>
            {{ row.core.coreNTAStats.pt }}/{{ row.core.coreNTAStats.ot }}/{{ row.core.coreNTAStats.slp }}/0/{{ row.core.coreNTAStats.ntaPoints }}
            </td>
            <td>
              0
            </td>

            <td>
            <a class="clickable-link" 
              (click)="viewNursingText(nursingPopUp, row.core.coreNTAStats.nurshingAIExtract)">
              {{ row.core.coreNTAStats.nursing }}
            </a>
            &nbsp;/&nbsp;
            <a class="clickable-link" 
              (click)="openNTAPopUp(row.core)">
              {{ row.core.coreNTAStats.ntaPoints }}
            </a>
          </td>
            <!-- <td>
              <a class="clickable-link" (click)="viewNursingText(nursingPopUp ,row.core.coreNTAStats.nurshingAIExtract)">
                {{ row.core.coreNTAStats.nursing }}
              </a>
            </td>
            <td>
              <a class="clickable-link" (click)="openNTAPopUp(row.core)">
                {{ row.core.coreNTAStats.ntaPoints }}
              </a>
            </td> -->
            <td>${{ row.core.coreNTAStats.rate }}</td>

            <td>
              <span class="alert-chip"
                *ngIf="row.core.coreNTAStats.alertMessage && row.core.coreNTAStats.alertMessage!=''"
                [ngStyle]="{ background: setAlertColor(row.core.coreNTAStats.alertType) }"
                matTooltip="{{ row.core.coreNTAStats.alertMessage }}" matTooltipPosition="above">
                <!-- {{ row.core.coreNTAStats.alertMessage }} -->
                
                <i class="fa fa-bell-o" aria-hidden="true"></i>
              </span>
            </td>
            <td>
              <!-- <i *ngIf="row.core.isAI==true" class="fa fa-reddit-alien" (click)="ProcessNTAGivenDocuments(row.core)" style="color: rgb(252, 110, 110);" aria-hidden="true"></i> -->
              <!-- <i class="fa fa-reddit-alien" (click)="ProcessNTAGivenDocuments(row.core)" style="color: rgb(252, 110, 110);" aria-hidden="true"></i> -->
              <i class="fa fa-reddit-alien" *ngIf="row.core.isPDPMAIRunning==0" [ngClass]="{ 'disabled-icon': !row.core.isAI }"
                (click)="row.core.isAI && ProcessNTAGivenDocuments(row.core)"
                style="color: rgb(252, 110, 110); cursor: pointer;" aria-hidden="true">
              </i>
               <div class="aiIcon" *ngIf="row.core.isPDPMAIRunning==1">
    <div class="ai-processing">
     <div class="brain-icon">🧠­</div>
     <div class="ai-text">AI</div>  
   </div>
  <span>Running</span>
  
</div>

              

            </td>            
            <td>
             <mat-icon class="ai-refresh-icon" (click)="ProcessRefreshAI(row.core)" *ngIf="row.core.isPDPMAIRunning==1" matTooltip="Refresh AI">refresh</mat-icon>
             <mat-icon class="processed" *ngIf="row.core.isPDPMAIRunning==2">check_circle</mat-icon>
              <mat-icon class="notProcessed" *ngIf="row.core.isPDPMAIRunning==2" (click)="ProcessNTAGivenDocuments(row.core)" matTooltip="Rerun">autorenew</mat-icon>
            </td>
            <td>
              <ng-container *ngFor="let folder of row.coreDocFolders">
                <p class="roleLabel">
                  <!-- <mat-icon>person_add</mat-icon> -->
                  {{ folder.folderName }}
                </p>

                <p class="doucmentInline">
                  <ng-container *ngFor="let ph of folder.placeholders">

                    <div class="tooltipHolder" [ngClass]="{'firstrow': rowIndex == 0 || rowIndex == 1 }">

                      <!-- <i *ngIf="ph.projectStatus != 3" class="fa fa-file-text-o grey" aria-hidden="true"></i> -->
                      <!-- <i *ngIf="ph.formID == 0" class="fa fa-file-text-o grey" aria-hidden="true"></i>  -->

                      <!-- For Blank PlaceHolder and upload document -->
                      <i *ngIf="ph.placeholderType ==0 && ph.projectID == 0 && ph.formType == 0"
                        class="fa fa-file-pdf-o grey" aria-hidden="true"></i>

                      <!-- For Forms PlaceHolder and Create Projects -->
                      <i *ngIf="ph.placeholderType ==2 && ph.projectID == 0 && ph.formType == 1"
                        class="fa fa-file-text-o grey" aria-hidden="true"></i>

                      <!-- For Upoladed documents and PDF -->
                      <i *ngIf="ph.placeholderType==1 && ph.formType==0 && ph.projectID == 0" class="fa fa-file-pdf-o"
                        style="color: red;" aria-hidden="true"></i>


                      <i *ngIf="ph.formID > 0 && ph.formType == 3" class="fa fa-html5 orange" style="color: #ed7b1a;"
                        aria-hidden="true"></i>
                      <i *ngIf="ph.formID > 0 && ph.projectID > 0 && (ph.projectStatus == 0 || ph.projectStatus == 1 || ph.projectStatus == 2)"
                        class="fa fa-file-text blue" style="color: #1E90FF;" aria-hidden="true"></i>
                      <i *ngIf="ph.formID > 0 && ph.projectID > 0 && ph.projectStatus == 3"
                        class="fa fa-check-circle-o green" aria-hidden="true"></i>
                      <!-- <i *ngIf="ph.projectStatus == 3"  class="fa fa-check-circle-o green" aria-hidden="true" matTooltip="{{ ph.placeholderName }} - Completed" matTooltipPosition="above"></i> -->


                      <div class="customTooltip newLook">

                        <div class="documentList">

                          <div class="topAligner">
                            <app-doc-icons *ngIf="ph.placeholderType==2 && ph.formType!=2 && ph.formType!=3"
                              [iconType]="'FORM'"></app-doc-icons>
                            <app-doc-icons *ngIf="ph.placeholderType==1 && ph.formType!=2 && ph.formType!=3"
                              [iconType]="'PDF'" (click)="openPDFViewer(ph,row.core)"></app-doc-icons>
                            <app-doc-icons [iconType]="'UPLOAD'" *ngIf="ph.placeholderType==0 && ph.formType!=2 && ph.formType!=3" ></app-doc-icons>

                            <div class="status">
                              <span *ngIf="ph.isFilled==true" class="formLabel fillForm">Filled </span>
                              <span *ngIf="ph.projectID>0 && ph.projectStatus==0" class="formLabel draftedForm">Draft
                              </span>
                              <span *ngIf="ph.projectID>0 && ph.projectStatus==1" class="formLabel sentForm">Sent
                              </span>
                              <span *ngIf="ph.projectID>0 && ph.projectStatus==2" class="formLabel inprogressForm">In
                                Progress </span>
                              <span *ngIf="ph.projectID>0 && ph.projectStatus==3"
                                class=" formLabel completedForm">Complete</span>
                              <span *ngIf="ph.projectID>0 && ph.projectStatus==4"
                                class="formLabel withDrawForm">Withdraw </span>
                              <span *ngIf="ph.projectID>0 && ph.projectStatus==5" class=" formLabel declineForm">Decline
                              </span>

                            </div>

                          </div>
                          <div class="docInfo">

                            {{ph.placeholderName}}
                          </div>
                          <div class="docaction">
                            <!-- if placeholder type ==2  and formtype ==1 then show form Icon  -->
                            <ul *ngIf="ph.placeholderType==2 && ph.formType==1">

                              <li *ngIf="ph.projectID > 0 && ph.projectStatus==0 || ph.projectStatus==1">
                                <a (click)="FillSelectForm(ph,row.core)">
                                  <i class="fa fa-pencil-square-o" aria-hidden="true"></i> Fill Data
                                </a>
                              </li>
                              <li *ngIf="ph.projectID==0">
                                <a (click)="signNow(ph.token,ph,row.core)">
                                  <i class="fa fa-pencil" aria-hidden="true"></i> Sign Now
                                </a>
                              </li>
                              <li *ngIf="ph.projectID==0">
                                <a (click)="creatProject(ph,row.core)">
                                  <i class="fa fa-plus" aria-hidden="true"></i> Create
                                </a>
                              </li>
                              <li *ngIf="ph.projectID>0  && ph.projectStatus!=3">
                                <a (click)="creatProject(ph,row.core)">
                                  <i class="fa fa-plus" aria-hidden="true"></i> Edit Signers
                                </a>
                              </li>
                              <li *ngIf="ph.projectID>0  && ph.projectStatus!=3">
                                <a (click)="EditForm(ph,row.core)">
                                  <i class="fa fa-plus" aria-hidden="true"></i> Edit Form
                                </a>
                              </li>
                              <li>
                                <a (click)="showDocumentDetails(ph,row.core)">
                                  <i class=""></i> Details
                                </a>
                              </li>
                            </ul>

                            <!-- if placeholder type ==0  and formtype ==0 then show placeholder  -->
                            <ul *ngIf="ph.placeholderType==0 && ph.formType==0">

                              <li>
                                <a>
                                  <input #Input hidden="true" type="file"
                                    (change)="onFileSelectPlaceHolder($event,ph, row.core)">
                                  <div class="uploadfile" (click)="Input.click()">
                                    <i class="fa fa-cloud-upload" aria-hidden="true"></i> Upload File
                                  </div>
                                </a>
                              </li>
                               <li>
                                <a class="uploadfile" (click)="openAttach(folder,row.core,ph)">                                 
                                  <div>
                                    <i class="fa fa-plus" aria-hidden="true"></i> Attach File
                                  </div>
                                </a>
                              </li>
                              <li>
                                <a (click)="showDocumentDetails(ph,row.core)">
                                  <i class="fa fa-info-circle" aria-hidden="true"></i> Details
                                </a>
                              </li>

                            </ul>

                            <!-- if placeholder type ==2 and formType==3 then show html Icon  -->
                            <ul *ngIf="ph.placeholderType==2 && ph.formType==3">
                              <li>
                                <a>
                                  <i class="fa fa-pencil-square-o" aria-hidden="true"></i> Fill
                                </a>
                              </li>
                              <li>
                                <a>
                                  <i class="fa fa-pencil" aria-hidden="true"></i> View
                                </a>
                              </li>
                              <li>
                                <a (click)="showDocumentDetails(ph,row.core)">
                                  <i class=""></i> Details
                                </a>
                              </li>

                            </ul>

                            <!-- if placeholder type ==1 and formType==0 then show pdf  -->
                            <ul *ngIf="ph.placeholderType==1 && ph.formType==0">
                              <!-- <li >
                                                   <a >
                                                    <i class="fa fa-pencil-square-o" aria-hidden="true"></i> Open AI
                                                  </a> 
                                                </li> -->

                              <!-- <li >
                                                   <a (click)="FillPlaceholderForDocument(ph,item.core)">
                                                    <i class="fa fa-pencil-square-o" aria-hidden="true"></i> Fill
                                                  </a> 
                                                </li> -->
                              <li>
                                <a (click)="showDocumentDetails(ph,row.core)">
                                  <i class=""></i> Details
                                </a>
                              </li>
                              <li>
                                <a (click)="DownloadSigleFile(ph,row.core)">
                                  <i class=""></i> Download
                                </a>
                              </li>

                            </ul>
                          </div>
                        </div>




                      </div>

                    </div>



                  </ng-container>


                </p>

              </ng-container>
            </td>
            <td>
                <p>                                    
                <mat-select placeholder = "Process Stage" [(ngModel)]="row.core.medicalCategoryID" [attr.value]="row.core.medicalCategoryID"
                  (selectionChange)="ChangeMedicalCategoryForCore(row.core.medicalCategoryID,$event.value,row.core.coreID,row)" (ngModel)="row.core.medicalCategoryID"  name = "processStage">
                  <mat-option value="0" >select</mat-option>
                  <mat-option *ngFor = "let stage of getPDPMStagesList" 
                      [value] = "stage.processStageID">
                      {{stage.processStageName}}
                  </mat-option>
                </mat-select>
                </p>
            </td>
            <td>
              <button mat-icon-button class="editbtn" (click)="openDialogEdit(updatevalue,row.core)" matTooltip="Edit">
                <mat-icon>edit</mat-icon>
              </button>           
            </td>

          </tr>

          <!-- If list is empty, show 'No records found' -->
          <tr *ngIf="showNoRecord==true">
            <td colspan="17" class="no-record">
              No records found
            </td>
          </tr>

        </tbody>
      </table>
    </div>
  </mat-card>



  <app-3cDocument-details *ngIf="openDocumentDetail==true" [ngClass]="{ open: openDocumentDetail }"
    [documentData]="selectedDocument" [transactionID]="transactionID" (closeEmit)="getClose($event)">
  </app-3cDocument-details>

  <app-document-viewer3c *ngIf="openDocumentViewers==true" [ngClass]="{ open: openDocumentViewers }"
    [documentData]="selectedDocument" [transactionID]="transactionID"
    (getCloseDocumentViewer)="getCloseDocumentViewer($event)">
  </app-document-viewer3c>




  <ng-template #addUpdateCore>
    <h2 mat-dialog-title>
      <span class="groupIcon">
        <mat-icon>group_add</mat-icon>
      </span>
      <p>Select & Add Participant</p>
      <button mat-icon-button (click)="getCloseCores()">
        <mat-icon>close</mat-icon>
      </button>

    </h2>

    <mat-dialog-content class="mat-typography">

      <div class="block mt-10">
        <mat-form-field appearance="outline" class="mt-10 mb-10" style="position: relative;">
          <mat-label>Search {{CoreShowName}}</mat-label>
          <input matInput maxlength="50" placeholder="Type & Select" aria-label="State" [matAutocomplete]="auto"
            (input)="searchCore($event.target.value)" [formControl]="stateCtrl" id="stateCtrlid">
          <mat-autocomplete #auto="matAutocomplete">
            <mat-option (click)="coreSelectedNew(core)" *ngFor="let core of attachedToCoreList" [value]="core.name">
              <span class="userlist" fxLayout="row" fxLayoutAlign="flex-start center">
                <div class="userpic">
                  <img *ngIf="core.imageUrl!='' " src="{{core.imageUrl}}" alt="">
                  <span class="username" *ngIf="core.imageUrl==''" class="username">
                    {{core.shortName}}
                  </span>
                </div>
                <div class="info">
                  <p> {{ core.name }}</p>
                  <p class="email">{{ core.email }}</p>
                </div>
              </span>
            </mat-option>
          </mat-autocomplete>

        </mat-form-field>

      </div>

      <ul class="selectedlist">
        <li *ngFor="let ass of addUpdateParticipantList">
          <div class="userndetail">
            <div class="userpic">
              <img *ngIf="ass.img!=''" src="{{ass.img}}" alt="">
              <span *ngIf="ass.img==''" class="username">
                {{ass.shortName}}
              </span>
            </div>
            <div class="details">
              <h4>{{ass.name}}</h4>
              <p>{{ass.email}}</p>
            </div>
            <div class="opt">
              <button mat-icon-button matTooltip="Remove">
                <mat-icon (click)="removeParticipant(ass)">cancel</mat-icon>
              </button>
            </div>
          </div>
        </li>
      </ul>

    </mat-dialog-content>


    <mat-form-field appearance="fill">
      <mat-label>Select pdpm Category</mat-label>
      <mat-select (selectionChange)="selectStage($event.value)">
        <mat-option *ngFor="let stat of getPDPMStagesList" [value]="stat.processStageID">
          {{ stat.processStageName }}
        </mat-option>
      </mat-select>

    </mat-form-field>


    <mat-dialog-actions>
      <button mat-button (click)="getCloseCores()">Cancel</button>
      <button mat-flat-button class="calltoaction" type="submit" (click)="onAddParticipant()" color="primary"
        [disabled]="showAddButton == true">
        <mat-icon *ngIf="spinner">
          <mat-spinner diameter="20">
          </mat-spinner>
        </mat-icon>
        Done
      </button>

    </mat-dialog-actions>
  </ng-template>



  <!-- <ng-template #updatevalue>
    <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>group_add</mat-icon>
    </span> 
    <p>Update Medical Stats</p>   
    <button mat-icon-button (click)="getCloseCores()">
      <mat-icon>close</mat-icon>
    </button>    
  </h2>

  <mat-dialog-content class="mat-typography">               
  <table class="edit-table">
   <thead>
    <tr>
      <th>LOS Day</th>
      <th>Payer</th>
      <th>HIPPS</th>
      <th>Care Level</th>
      <th>PT</th>
      <th>OT</th>
      <th>SLP</th>
      <th>Nursing</th>     
      <th>Rate</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td><input matInput  [(ngModel)]="losDay" (keypress)="numberOnly($event)" style="width:60px;"/></td>
      <td>
       <input matInput  [(ngModel)]="payer" maxlength="100" placeholder="Payer" />
      </td>
      <td><input matInput  [(ngModel)]="hipps" maxlength="100" placeholder="HIPPS" /></td>
      <td><input matInput  [(ngModel)]="careLevel" maxlength="100" placeholder="Care Level"/></td>
     
      <td><input matInput [(ngModel)]="pt" (keypress)="numberOnly($event)" style="width:40px; text-align:center;" /></td>
      <td><input matInput [(ngModel)]="ot" (keypress)="numberOnly($event)" style="width:40px; text-align:center;" /></td>
      <td><input matInput [(ngModel)]="slp" (keypress)="numberOnly($event)" style="width:40px; text-align:center;" /></td>

      
       <td>
        <mat-select placeholder = "Select Nursing" [(ngModel)]="nursing" [attr.value]="nursing"
                                         (ngModel)="nursing"  name = "Nusring">
                                        <mat-option value="" >Select Nursing</mat-option>
                                        <mat-option value="ES" >Extensive Services (ES) (top of hierarchy)</mat-option>
                                        <mat-option value="SCH" >Special Care High (SCH) (not exhaustive)</mat-option>
                                        <mat-option value="SCL" >Special Care Low (SCL)</mat-option>
                                        <mat-option value="CC" >Clinically Complex (CC)</mat-option>
                                        <mat-option value="RPF" >Behavioral & Cognitive / Reduced Physical Function (RPF)</mat-option>
                           

                                       
                                </mat-select>
      </td>
     <td>
      <div class="currency-input">
        <span class="currency-symbol">$</span>
        <input matInput [(ngModel)]="rate" (keypress)="numberOnly($event)" />
      </div>
    </td>

    </tr>
  </tbody>
</table>


  </mat-dialog-content>
  

  <mat-dialog-actions>
    <button mat-button (click)="getCloseCores()">Cancel</button>
    <button mat-flat-button class="calltoaction" type="submit" 
      (click)="CoreMedicalStatsUpdate()" color="primary">
      <mat-icon *ngIf="spinner">
      <mat-spinner diameter="20">
      </mat-spinner>
    </mat-icon>
      Update
    </button>  
   
  </mat-dialog-actions>
</ng-template> -->

  <ng-template #updatevalue>
    <h2 mat-dialog-title>
      <span class="groupIcon">
        <mat-icon>group_add</mat-icon>
      </span>
      <span>Update Medical Stats</span>
      <button mat-icon-button (click)="getCloseCores()" class="close-btn">
        <mat-icon>close</mat-icon>
      </button>
    </h2>

    <mat-dialog-content class="mat-typography">
      <form class="form-grid">
        
        <mat-form-field appearance="outline">
          <mat-label>Payer</mat-label>
          <input matInput [(ngModel)]="payer" name="payer" maxlength="100" />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>HIPPS</mat-label>
          <input matInput [(ngModel)]="hipps" name="hipps" maxlength="100" />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Care Level</mat-label>
          <input matInput [(ngModel)]="careLevel" name="careLevel" maxlength="100" />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>PT</mat-label>
          <input matInput [(ngModel)]="pt" name="pt" (keypress)="numberOnly($event)" />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>OT</mat-label>
          <input matInput [(ngModel)]="ot" name="ot" (keypress)="numberOnly($event)" />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>SLP</mat-label>
          <input matInput [(ngModel)]="slp" name="slp" (keypress)="numberOnly($event)" />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Nursing</mat-label>
          <mat-select [(ngModel)]="nursing" name="nursing">
            <mat-option value="">Select Nursing</mat-option>
            <mat-option value="ES">Extensive Services (ES) (top of hierarchy)</mat-option>
            <mat-option value="SCH">Special Care High (SCH)</mat-option>
            <mat-option value="SCL">Special Care Low (SCL)</mat-option>
            <mat-option value="CC">Clinically Complex (CC)</mat-option>
            <mat-option value="RPF">Behavioral & Cognitive / Reduced Physical Function (RPF)</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Rate</mat-label>
          <input matInput [(ngModel)]="rate" name="rate" (keypress)="numberOnly($event)" placeholder="0.00">
          <span matPrefix>$&nbsp;</span>
        </mat-form-field>


        <mat-form-field appearance="outline">
          <mat-label>LOS Day Calculation</mat-label>
          <mat-select [(ngModel)]="losDayCalculation" name="losDayCalculation">
            <mat-option value="0">None</mat-option>
            <mat-option value="1">Admission to Discharge</mat-option>
            <mat-option value="2">Admission to Today</mat-option>
            <mat-option value="3">Manual Days</mat-option>
          </mat-select>
        </mat-form-field>

<mat-form-field appearance="outline">
  <mat-label>LOS Day</mat-label>
  <input 
    matInput 
    [(ngModel)]="losDay" 
    name="losDay" 
    (keypress)="numberOnly($event)" 
    [disabled]="losDayCalculation != '3'" />
</mat-form-field>
        
<!-- Admission Date -->
<div class="date-field-with-clear">
  <mat-form-field appearance="outline" class="flex-1">
    <mat-label>Admission Date</mat-label>
    <input 
      matInput 
      [readonly]="true" 
      [matDatepicker]="admissionPicker" 
      [(ngModel)]="admissionDate"
      name="admissionDate" 
      (dateChange)="dischargeDate = null">

    <mat-datepicker-toggle matSuffix [for]="admissionPicker"></mat-datepicker-toggle>
    <mat-datepicker #admissionPicker></mat-datepicker>
  </mat-form-field>

  <!-- Clear Icon OUTSIDE -->
  <button 
    *ngIf="admissionDate" 
    mat-icon-button 
    class="clear-btn"
    (click)="admissionDate = null; dischargeDate = null" 
    matTooltip="Clear admission date" 
    tabindex="-1">
    <mat-icon>close</mat-icon>
  </button>
</div>


<!-- Discharge Date -->
<div class="date-field-with-clear">
  <mat-form-field appearance="outline" class="flex-1">
    <mat-label>Discharge Date</mat-label>
    <input 
      matInput 
      [readonly]="true" 
      [matDatepicker]="dischargePicker" 
      [(ngModel)]="dischargeDate"
      name="dischargeDate" 
      [min]="admissionDate">

    <mat-datepicker-toggle matSuffix [for]="dischargePicker"></mat-datepicker-toggle>
    <mat-datepicker #dischargePicker></mat-datepicker>
  </mat-form-field>

  <!-- Clear Icon OUTSIDE -->
  <button 
    *ngIf="dischargeDate" 
    mat-icon-button 
    class="clear-btn"
    (click)="dischargeDate = null" 
    matTooltip="Clear discharge date"
    tabindex="-1">
    <mat-icon>close</mat-icon>
  </button>
</div>


      </form>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button mat-button (click)="getCloseCores()">Cancel</button>
      <button mat-flat-button color="primary" class="calltoaction" type="submit" (click)="CoreMedicalStatsUpdate()">
        <mat-icon *ngIf="spinner">
          <mat-spinner diameter="20"></mat-spinner>
        </mat-icon>
        Update
      </button>
    </mat-dialog-actions>
  </ng-template>




  <app-addnew *ngIf="showAddCore" (closeAdd)="getCloseCore()" [name]="searchName"
    (selectedRecordForTypeOfParticipant)=saveAddNew3C($event) [isShared]="isShare" [SendingFor]="sendFrom"
    [mainModuleName]='mainModuleName' [modulename]='Module' [ngClass]="{'open': showAddCore}">
  </app-addnew>

  <app-loader></app-loader>

</div>
<ng-template #nursingPopUp>
   <h2 mat-dialog-title>    
     Nursing Details
    <button mat-icon-button (click)="close()"><mat-icon>close</mat-icon></button>
  </h2>

  <!-- <h2 matDialogTitle class="nta-dialog-titles">Nursing Details</h2>
  <button mat-icon-button (click)="close()"><mat-icon>close</mat-icon></button> -->
 <mat-dialog-content class="details-content">
  <div class="preformatted-text" *ngIf="nursingText">
    {{nursingText}}
  </div>
  <div class="preformatted-text" *ngIf="!nursingText">
    No data available.
  </div>
</mat-dialog-content>
  <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-button color="primary" (click)="close()"> Cancel </button>
  </mat-dialog-actions>
</ng-template>

<app-details *ngIf="showDetail" [ngClass]="{ open: showDetail }" [transactionID]='transactionID'
  [modulenames]='mainModuleNameForDetails' (closeDetail)="getCloseDetails($event)"
  [openFor]='openFor'>
</app-details>

   <ng-template #selectFavColor>
    <h2 mat-dialog-title>
      <span class="groupIcon"><mat-icon>rocket_launch</mat-icon></span>
      Add Color
      <button mat-icon-button (click)="closeColor()">
        <mat-icon>close</mat-icon>
      </button>
    </h2>
    <mat-dialog-content>

     <div class="color-list">
        <ng-container *ngFor="let col of colors">
          <span
            (click)="selectedColors(col.color)"
            [ngStyle]="{'background-color': col.color}"
            class="color-box">
          </span>
        </ng-container>
      </div>


    </mat-dialog-content>
     <mat-dialog-actions class="mt-10" align="start" fxLayout="row" fxLayoutAlign="space-between center">
    </mat-dialog-actions>

  </ng-template>
   <ng-template #selectimpFavColor>
    <h2 mat-dialog-title>
      <span class="groupIcon"><mat-icon>rocket_launch</mat-icon></span>
      Add Color
      <button mat-icon-button (click)="closeColor()">
        <mat-icon>close</mat-icon>
      </button>
    </h2>
    <mat-dialog-content>

     <div class="color-list">
        <ng-container *ngFor="let col of colors">
          <span
            (click)="selectedImpColors(col.color)"
            [ngStyle]="{'background-color': col.color}"
            class="color-box">
          </span>
        </ng-container>
      </div>


    </mat-dialog-content>
     <mat-dialog-actions class="mt-10" align="start" fxLayout="row" fxLayoutAlign="space-between center">
    </mat-dialog-actions>

  </ng-template>
  